module.exports = __webpack_public_path__ + "img/DefaultUserImage.5a0a4a60.svg";